import { Component, OnInit, Inject, Optional } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialog } from '@angular/material/dialog';
import { ViewNotesComponent } from '../view-notes/view-notes.component';

@Component({
  selector: 'view-wo-details',
  templateUrl: './view-wo-details.component.html',
  styleUrls: ['./view-wo-details.component.scss'],
})
export class ViewWoDetailsComponent implements OnInit {
  getWObyEvent: any;

  constructor(public dialogRef: MatDialogRef<ViewWoDetailsComponent>,
    @Optional() @Inject(MAT_DIALOG_DATA) public data: any,
    public dialog: MatDialog,
  ) {
    dialogRef.disableClose = true;
  }

  ngOnInit() {
    this.getWObyEvent = this.data;
  }

  onNoClick(): void {
    this.dialogRef.close();
  }

  ViewNote(dataKey) {
    this.dialog.open(ViewNotesComponent, {
      hasBackdrop: true,
      backdropClass: 'cdk-overlay-transparent-backdrop',
      height: '90%',
      maxHeight: '90%',
      width: '60%',
      position: {
        top: '5%',
        bottom: '',
        left: '',
        right: '',
      },
      data: { data: dataKey },
    });
  }

}
